
import { mapGetters } from "vuex";
import logo from "~/assets/images/logo.png";
import CommonHeader from "../components/common/common-header.vue";
export default {
  components: { CommonHeader },
  data() {
    return {
      logo
    };
  },
  computed: {
    ...mapGetters("auth", ["userInfoLoading"]),
    isLoginSignupPage() {
      return (
        this.$route.name === "login-signup" || this.$route.name === "signup"
      );
    }
  }
};
